(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-multiple-featured"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  // Check if .multiple-blog-section has no child div
  if ($('.multiple-blog-section .block__blog-content-blogs .multiple-blog-section-main .multiple-blog-section-first .multiple-blog-section-flex').children().length === 0) {
    // If no child div is found, hide .multiple-blog-section
    $('.multiple-blog-section').hide();
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightHandler);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.ticking = false;

window.addEventListener('scroll', () => {
  if (!this.ticking) {
    requestAnimationFrame(() => {
      this.onScrollHandler();
      this.ticking = false;
    });
    this.ticking = true;
  }
});
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.matchMedia('(max-width: 990px)').removeEventListener('change', this.setHeaderHeightHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
this.updateHeaderHeight();
        if (this.preventHide) return;
        

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
this.updateHeaderHeight();
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
  this.header.classList.remove('scrolled-past-header');
  this.updateHeaderHeight();
  requestAnimationFrame(this.reset.bind(this));
}
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
updateHeaderHeight() {
  requestAnimationFrame(() => {
    const height = `${this.header.offsetHeight}px`;
    if (document.documentElement.style.getPropertyValue('--header-height') !== height) {
      document.documentElement.style.setProperty('--header-height', height);
    }
  });
}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    var slickOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: true,
        dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<button class="slick-arrow-review-main home-slider slick-arrow-review-left" aria-label="Previous Slide"><span class="slick-arrow-home prev-arrow" ><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.39275 7.37506L8.74525 4.02255L7.86137 3.13867L3 8.00006L7.86137 12.8614L8.74525 11.9775L5.39275 8.62506H13V7.37506H5.39275Z" fill="white"/></svg></span></button>',
        nextArrow: '<button class="slick-arrow-review-main home-slider slick-arrow-review-right" aria-label="Next Slide"><span class="slick-arrow-home next-arrow" ><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.6073 7.37506L7.25475 4.02255L8.13863 3.13867L13 8.00006L8.13863 12.8614L7.25475 11.9775L10.6073 8.62506H3V7.37506H10.6073Z" fill="white"/></svg></span></button>'
    };

    var $carousel = $('.product-video-review-flex .product-video-main .row');

    if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick(slickOptions);
    }

    $carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $currentSlide = $(slick.$slides[currentSlide]);
        var $currentVideo = $currentSlide.find('iframe[src*="youtube"]');
        if ($currentVideo.length > 0) {
            $currentVideo[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    });

    $(".dp-review-left").click(function () {
        $(".product-review-blocks").slick("slickPrev");
    });

    $(".dp-review-right").click(function () {
        $(".product-review-blocks").slick("slickNext");
    });

    $(".dp-review-left").addClass("slick-disabled");
    $(".product-review-blocks").on("afterChange", function () {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".dp-review-left").addClass("slick-disabled");
        } else {
            $(".dp-review-left").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".dp-review-right").addClass("slick-disabled");
        } else {
            $(".dp-review-right").removeClass("slick-disabled");
        }
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero"] && !Shopify.designMode) return;
  try {
     

// $(document).ready(function(){
//     var playPauseVideoBtn = $('.playPauseVideo'); 
//     playPauseVideoBtn.each(function(el, val){
//        if(val.classList.contains('video-play')){
//          let videoPlay = val.dataset.video;
//          if ( $(`#${videoPlay}`)[0].paused) {
//            $(`#${videoPlay}`)[0].play(); 
//            val.classList.remove('video-pause')
//            val.classList.add('video-play');
//          } else {
//           $(`#${videoPlay}`)[0].pause(); 
//           val.classList.remove('video-play');
//           val.classList.add('video-pause');
//          }
//        }
//     });
// });
$('.block__hero--content-wrapper').each(function(){ 
    
    var $currentCollection = $(this).attr('id');
    var $video = $('#' + $currentCollection + ' .video');

    // Check if the video element exists
    if ($video.length > 0) {
        var $playPauseVideoButton = $(this).find('.playPauseVideo');
        var $volumeControl = $(this).find('.volumeControl');
        var $volumeIcon = $(this).find('.volumeicon');
        var $volumeControlWrapper = $(this).find('.volume-control-wrapper');

        var autoplayClass =  $playPauseVideoButton.data('autoplay')  

          // Set default classes
        // $playPauseVideoButton.addClass('video-pause');

        $playPauseVideoButton.addClass(`${autoplayClass}`);

        if($playPauseVideoButton.hasClass('video-play')){
                 $video[0].play();
                 $(this).removeClass('video-pause').addClass('video-play');
        }else{
              $video[0].play(); 
              $(this).removeClass('video-pause').addClass('video-pause');
        }

          // Default play video

        updateAudioClass(); // Initial update based on the volume control value

        $volumeIcon.on("click", function() {
            if ($video[0].volume === 0) {
                $video[0].volume = 1;
                $volumeControlWrapper.removeClass('audio-mute').addClass('audio-play');
                $volumeControl.val(1); // Set volume control value to 1 when audio is unmuted
                $video.prop('muted', false)
            } else {
                $video[0].volume = 0;
                $volumeControlWrapper.removeClass('audio-play').addClass('audio-mute');
                $volumeControl.val(0); // Set volume control value to 0 when audio is muted          
                $video.prop('muted', true);
            }
        });

        $playPauseVideoButton.on("click", function() {
            if ($video[0].paused) {
                $video[0].play();
                $(this).removeClass('video-pause').addClass('video-play');
            } else {
                $video[0].pause();
                $(this).removeClass('video-play').addClass('video-pause');
            }
        });

        $volumeControl.on("input", function() {
         
            $video[0].volume = $volumeControl.val();
            updateAudioClass(); // Update the audio class based on the volume control value
        });

        function updateAudioClass() {
           
            var percentage = ($volumeControl.val() - $volumeControl.attr('min')) / ($volumeControl.attr('max') - $volumeControl.attr('min')) * 100;
            if ($video[0].volume === 0) {
                $volumeControl.val(0); // Set volume control value to 0 when audio is muted
            }
            if (percentage === 0) {
                $volumeControlWrapper.removeClass('audio-play').addClass('audio-mute');
                $video.prop('muted', true);
                $volumeControl.val(percentage)
            } else {
                $volumeControlWrapper.removeClass('audio-mute').addClass('audio-play');
                $video.prop('muted', false)
                $volumeControl.val(percentage);
            }
        }
        // if($playPauseVideoButton.hasClass('video-play')){
        //       
        //         if ($video[0].paused) {
        //         $video[0].play();
        //         $(this).removeClass('video-pause').addClass('video-play');
        //         } else {
        //             $video[0].pause();
        //             $(this).removeClass('video-play').addClass('video-pause');
        //         }
        //       }
    }
});

var $slider = $('.block__hero-content-main');

function pauseCurrentVideo() {
    
    var $currentSlide = $slider.find('.slick-current');
    var $video = $currentSlide.find('.video');
    
    // Check if the video element exists
    if ($video.length > 0 && !$video[0].paused) {
        $video[0].pause();
        $currentSlide.find('.playPauseVideo').removeClass('video-play').addClass('video-pause');
    }
} 

$slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    
    pauseCurrentVideo();
});

const settings={
  fill: '#fff',
  background: '#A4A4A4'
}

const sliders = document.querySelectorAll('.volume-control-wrapper');

Array.prototype.forEach.call(sliders,(slider)=>{
  slider.querySelector('input').addEventListener('input', (event)=>{
    applyFill(event.target);
  });
  applyFill(slider.querySelector('input'));
});

function applyFill(slider) {
  const percentage = 100*(slider.value-slider.min)/(slider.max-slider.min);
  const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background} ${percentage+0.1}%)`;
  slider.style.background = bg;
} 

// // Define the isInView function
// function isInView(elem) {
//     var bounding = elem.getBoundingClientRect();
//     return (
//         bounding.top >= 0 &&
//         bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
//     );
// }

// // Add event listener for keydown events on the document body
// $(document).on('keydown', function(e) {
//     if (e.which === 32 || e.which === 13) {
//         var $heroSection = $('.hero-section');
//         if (isInView($heroSection[0])) {
//             var $currentSlide = $slider.find('.slick-current');
//             var $video = $currentSlide.find('.video');
//             if ($video.length > 0) {
//                 if ($video[0].paused) {
//                     $video[0].play();
//                     $currentSlide.find('.playPauseVideo').removeClass('video-pause').addClass('video-play');
//                 } else {
//                     $video[0].pause();
//                     $currentSlide.find('.playPauseVideo').removeClass('video-play').addClass('video-pause');
//                 }
//             }
//         }
//     }
// });

// // Add event listener for scroll events on the document
// $(document).on('scroll', function() {
//     var $heroSection = $('.hero-section');
//     if (isInView($heroSection[0])) {
//         var $currentSlide = $slider.find('.slick-current');
//         var $video = $currentSlide.find('.video');
//         if ($video.length > 0) {
//             if ($video[0].paused) {
//                 $video[0].play();
//                 $currentSlide.find('.playPauseVideo').removeClass('video-pause').addClass('video-play');
//             } else {
//                 $video[0].pause();
//                 $currentSlide.find('.playPauseVideo').removeClass('video-play').addClass('video-pause');
//             }
//         }
//     }
// });

  } catch(e) { console.error(e); }
})();
})();
